// @ts-nocheck
/* eslint-disable */
export const arrowRightIcon = {
    data: `<svg viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.4375 10.125L5.5625 6L1.4375 1.875" stroke="currentColor" stroke-width="2.0625" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'arrow-right' as const
};